import React, { Fragment, memo } from 'react'
import PropTypes from 'prop-types'
import { isNilEmpty } from 'Utils'
import { _PrevSearchResultItem, _PrevSearchResultTitle } from './styles'

export const PrevSearchManager = ({ maxCount, storageKey, localStorage }) => {
  // init values
  const _maxCount = maxCount || 3
  const prevSearchesJson = localStorage.getItem(storageKey)
  let prevSearches = prevSearchesJson ? JSON.parse(prevSearchesJson) : []
  // public functions
  const addNewSearch = (suggestion) => {
    const isExisting = prevSearches.some(prevSearch => prevSearch.title === suggestion.title)
    if(isExisting) return prevSearches
    if(prevSearches.length >= _maxCount) {
      prevSearches.pop()
    }
    prevSearches = [suggestion, ...prevSearches]
    localStorage.setItem(storageKey, JSON.stringify(prevSearches))
    return prevSearches
  }
  const getSearches = () => (prevSearches)
  return {
    addNewSearch,
    getSearches,
  }
}


const PrevSearches = ({
  showPrevSearches,
  onSuggestionSelect,
  areaFilterTags,
  stateUserPrevSearches,
}) => {
  const onPrevSearchClick = (e, suggestion) => {
    e.preventDefault()
    e.stopPropagation()
    onSuggestionSelect(suggestion, false)
  }


  const searchHistoryResult = stateUserPrevSearches?.filter(search =>
    !areaFilterTags?.find(filterTag => filterTag.area_id === search.filter_value)).slice(0, 3)
  return (
    <div>
      {
        showPrevSearches && !isNilEmpty(searchHistoryResult) && (
          <Fragment>
            <_PrevSearchResultTitle
              title="Search History"
              icon=""
            />
            {
              searchHistoryResult?.map(suggestion => (
                <div
                  key={'prevSearch' + suggestion.url}
                  data-test-id="previousSuggestion"
                  onClick={(e) => onPrevSearchClick(e, suggestion)}
                >
                  <_PrevSearchResultItem
                    key={suggestion.objectId}
                    item={suggestion}
                    query={''}
                  />
                </div>
              ),
              )
            }
          </Fragment>

        )
      }
    </div>
  )
}

PrevSearches.propTypes = {
  showPrevSearches: PropTypes.bool,
  onSuggestionSelect: PropTypes.func,
  areaFilterTags: PropTypes.arrayOf(PropTypes.shape({
    area_id: PropTypes.number,
  })),
  stateUserPrevSearches: PropTypes.arrayOf(PropTypes.shape({})),
}

export default memo(PrevSearches)
